import { IErknmAgreementExecution } from 'APIPackage/KnmModule/interfaces/IErknmAgreementExecution';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';

import { IErknmFormAgreementExecution } from '../interfaces/IErknmFormAgreementExecution';

export const convertAgreementsExecutionFormValuesToData = (
  execution: IErknmFormAgreementExecution | undefined,
): IErknmAgreementExecution | null => {
  if (!execution) return null;

  return {
    decision: typeof execution.decision?.value === 'boolean' ? execution.decision?.value : null,
    executionDate: convertFormDateValueToKnmDataDate(execution.executionDate),
    attachments: convertKnmDocumentAttachmentsFormValuesToKnmData(execution.attachments) || null,
    fioSigner: execution.fioSigner?.trim() || null,
    titleSigner: execution.titleSigner?.value || null,
  };
};
